import React from "react";
import { FileText, Check } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { POLICIES } from "../mock";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "./ui/dialog";
import { ScrollArea } from "./ui/scroll-area";

const PoliciesModal = () => {
  const { t, lang } = useLanguage();
  const sections = POLICIES[lang] || POLICIES.es;

  return (
    <Dialog>
      <DialogTrigger asChild>
        <button className="text-white/70 hover:text-cyan-300 text-sm transition-colors text-left">
          {t("policiesLink")}
        </button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-2xl max-h-[85vh] p-0 gap-0 overflow-hidden">
        <DialogHeader className="px-6 pt-6 pb-4 border-b border-teal-100">
          <DialogTitle className="flex items-center gap-2.5 font-display text-xl text-[#0d3b43]">
            <span className="w-9 h-9 rounded-xl bg-teal-600 text-white flex items-center justify-center">
              <FileText className="w-5 h-5" />
            </span>
            {t("policiesTitle")}
          </DialogTitle>
          <DialogDescription className="text-slate-500 pt-1">
            {t("policiesIntro")}
          </DialogDescription>
        </DialogHeader>

        <ScrollArea className="max-h-[62vh] px-6 py-5">
          <div className="space-y-8 pr-2">
            {sections.map((sec, i) => (
              <div key={sec.title}>
                <div className="flex items-center gap-2.5 mb-4">
                  <span className="w-7 h-7 rounded-lg bg-teal-600 text-white font-bold flex items-center justify-center text-sm">
                    {i + 1}
                  </span>
                  <h3 className="font-display font-bold text-lg text-[#0d3b43]">
                    {sec.title}
                  </h3>
                </div>
                <ul className="space-y-2.5">
                  {sec.items.map((item, idx) => (
                    <li
                      key={idx}
                      className="flex items-start gap-2.5 rounded-lg border border-teal-100 bg-teal-50/40 p-3"
                    >
                      <Check className="w-4 h-4 text-teal-600 shrink-0 mt-0.5" />
                      <span className="text-sm leading-relaxed text-slate-700">
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};

export default PoliciesModal;
